
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/saved-jobs",
      function () {
        return require("private-next-pages/saved-jobs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/saved-jobs"])
      });
    }
  